import * as XLSX from "xlsx";

const DownloadExcel = ({ transactions, fileName }) => {
  const handleExport = () => {
    const exportData = transactions.map((transaction) => ({
      Type: transaction.type || "N/A",
      RNN: transaction.responseUTR || "N/A",
      Payer: transaction.dataItem.customerName || "N/A",
      Amount: transaction.requestAmount || 0,
      OrderId: transaction.orderId || "N/A",
      VPA: JSON.parse(transaction.request).vpa,
      Status: "Pending",
      "TXN DATE": new Date(transaction.createdAt).toLocaleDateString() || "N/A",
      "ADJ DATE": null,
      Email: transaction.dataItem.customerEmail || "N/A",
      Phone: transaction.dataItem.customerMobile || "N/A",
    }));

    const worksheet = XLSX.utils.json_to_sheet(exportData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Transactions");
    XLSX.writeFile(workbook, `${fileName}.xlsx`);
  };

  return (
    <button className="btn export" onClick={handleExport}
    style={{marginLeft:'40%',color:'black'}}>
      Export
    </button>
  );
};

export default DownloadExcel;
